import { useMemberId } from '@trello/authentication';

import { useBoardSwitcherMemberFragment } from './BoardSwitcherMemberFragment.generated';

export const useIsGuestWorkspace = (workspaceId: string | null) => {
  const memberId = useMemberId();

  const { data } = useBoardSwitcherMemberFragment({
    from: { id: memberId },
    returnPartialData: true,
  });

  const workspaces = data?.organizations ?? [];

  const workspaceIds = workspaces.map((workspace) => workspace.id);

  return !!workspaceId && !workspaceIds.includes(workspaceId);
};
